import { DocumentationTranslationKeys } from 'intl/keys';
import type { TranslationKey } from 'intl/types/translationKey';
import { ExportedVersionSetting } from 'shared/domain/issue/linkedDocumentation/operations';

const EXPORTED_VERSION_SETTING_NOT_SAVED_KEYS: Record<ExportedVersionSetting, TranslationKey> = {
  [ExportedVersionSetting.name]: DocumentationTranslationKeys.exportVersionNameNotSaved,
  [ExportedVersionSetting.current]: DocumentationTranslationKeys.exportVersionCurrentNotSaved,
};

/** Tells that a setting of an exported version could not be saved and where to set it (PT-7318). */
export function exportedVersionSettingNotSavedKey(setting: ExportedVersionSetting): TranslationKey {
  return EXPORTED_VERSION_SETTING_NOT_SAVED_KEYS[setting];
}
